import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
// import loadable from '@loadable/component';
import { ListGroup, ListGroupItem, ListGroupItemSubtitle, ListGroupItemTitle } from '@vds/lists';

import { selectStateCache } from '../@selectors';
import { checkoutLabels } from '../Components/labels';
import ContactInfoEdit from './ContactInfoEdit';
import { useCheckoutHooks } from '../@Redux/checkout.hooks';
import { getContactNumber } from '../../../common/ContactInfoUtils';

const ContactInfo = () => {
  const dispatch = useDispatch();
  const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const { primaryUserInfo = {} } = useCheckoutHooks(stateCache);
  const [showContactInfoEditForm, setShowContactInfoEditForm] = useState(false);

  const showContactinfoEditForm = (hideContactInfoForm) => {
    if (hideContactInfoForm) {
      setShowContactInfoEditForm(false);
    } else {
      setShowContactInfoEditForm(true);
      dispatch({ type: 'CONTACT_INFO_EDIT_RESPONSE', data: '' });
    }
  };
  useEffect(() => {
    if (!primaryUserInfo.firstName || !primaryUserInfo.lastName || !primaryUserInfo.emailId || !primaryUserInfo.address.phoneNumber) {
      setShowContactInfoEditForm(true);
    }
  }, [primaryUserInfo]);
  useEffect(() => {
    dispatch({ type: 'CONTACT_INFO_EDIT_RESPONSE', data: '' });
  }, []);
  return (
    <>
      {!showContactInfoEditForm && (
        <div>
          <ListGroup topLine={false} bottomLine surface="light" viewport="mobile">
            <ListGroupItem
              textHierarchy="subtitleProminent"
              actionElement="icon"
              icon={{ onClick: () => showContactinfoEditForm() }}
              data-track='{"type":"link","name":"customer information|express checkout","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}'
            >
              <ListGroupItemTitle bold={false}>
                {primaryUserInfo?.firstName} {primaryUserInfo?.lastName}, {primaryUserInfo?.emailId}
                <br />
                {getContactNumber(primaryUserInfo)}
              </ListGroupItemTitle>
              <ListGroupItemSubtitle>{checkoutLabels.CustomerInformation}</ListGroupItemSubtitle>
            </ListGroupItem>
          </ListGroup>
        </div>
      )}
      {showContactInfoEditForm && <ContactInfoEdit showContactinfoEditForm={showContactinfoEditForm} />}
    </>
  );
};

export default ContactInfo;
